import { render, staticRenderFns } from "./selfDialogue.vue?vue&type=template&id=71f974b8&scoped=true"
import script from "./selfDialogue.vue?vue&type=script&lang=js"
export * from "./selfDialogue.vue?vue&type=script&lang=js"
import style0 from "./selfDialogue.vue?vue&type=style&index=0&id=71f974b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f974b8",
  null
  
)

export default component.exports